import type { Alias } from '#shared/api/schema';
import { CONSTRUCTOR_LOYALTY_PAGES } from '../constants';

export const isConstructorPageLoyalty = (alias: Alias) => alias && CONSTRUCTOR_LOYALTY_PAGES.includes(alias);
